import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

class Help extends Component {
	render() {
		return (
			<nav className="nav pt-3 pt-lg-4 text-right">
				<div className="container-fluid mt-1 mb-3">
					<h1 className="sr-only visually-hidden">Help</h1>
					<span className="small font-weight-bold">
						Besoin d'aide ?{" "}
						<a className="text-info" href="/faqs">
							FAQ
						</a>
					</span>
				</div>
			</nav>
		);
	}
}

const mapStateToProps = (state) => ({
	example: state.example,
});
const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(Help);